import { createHOC } from 'vue-hoc'
import VBtn from 'vuetify/lib/components/VBtn'
import _ from 'lodash'

const options = {
  name: 'DebounceVBtn',
  methods: {
    deBouncedClick: _.debounce(function (arg) {
      this.$emit('click', arg)
    }, 500, { 'leading': true, 'maxWait': 500, 'trailing': false }),
  },
}

const renderWith = {
  listeners: {
    click (arg) {
      this.deBouncedClick(arg)
    },
  },
}

const DebounceVBtn = createHOC(VBtn, options, renderWith)
export default DebounceVBtn
